<template>
  <textarea ref="textarea" :value="value" rows="1" @input="changeHeight" />
</template>

<script lang="ts">
import {defineComponent} from "vue";

export default defineComponent({
  name: "AutoResizeTextArea",
  props: {
    value: String
  },
  async mounted() {
    // не нравится, как setTimeout работает, но пока нет идей, как это исправить
    this.$nextTick(() => {
      this.changeHeight();
    });
  },
  methods: {
    async changeHeight() {
      const textarea = this.$refs.textarea as HTMLTextAreaElement;
      if (!textarea) {
        return;
      }
      const MIN_HEIGHT = 20;
      textarea.style.height = "0px";
      textarea.style.height =
        Math.max(MIN_HEIGHT, textarea.scrollHeight) + "px";
    }
  },
  watch: {
    value() {
      this.$nextTick(() => {
        this.changeHeight();
      });
    }
  }
});
</script>
